export const DEFAULT_RECEIVING_BANK_NAME = 'Valley';

export function formatTwelveBankAccountLabel(bankAccount) {
  if (!bankAccount) {
    return '';
  }
  return `${bankAccount.name} - ${bankAccount.accountNumber}`;
}

export function formatTwelveBankAccountLabelById(bankAccountsById, accountId) {
  if (accountId === null || accountId === undefined) {
    return '';
  }
  return formatTwelveBankAccountLabel(bankAccountsById?.[accountId]);
}

/**
 * Builds select options for Twelve bank accounts.
 * Enabled accounts are selectable; legacy account IDs already on a record
 * are kept so they still display even when disabled.
 */
export function buildTwelveBankAccountOptions(
  bankAccounts,
  { includeAccountIds = [] } = {}
) {
  const includeIds = new Set(
    (includeAccountIds || []).filter((accountId) => Boolean(accountId))
  );

  return [...(bankAccounts || [])]
    .filter(
      (bankAccount) =>
        bankAccount.enabled || includeIds.has(bankAccount.id)
    )
    .sort((left, right) => {
      if (left.enabled !== right.enabled) {
        return left.enabled ? -1 : 1;
      }
      return `${left.name}-${left.accountNumber}`.localeCompare(
        `${right.name}-${right.accountNumber}`
      );
    })
    .map((bankAccount) => ({
      label: formatTwelveBankAccountLabel(bankAccount),
      value: bankAccount.id,
    }));
}

export function getDefaultReceivingBankAccountId(bankAccounts) {
  const enabledAccounts = (bankAccounts || []).filter(
    (bankAccount) => bankAccount.enabled
  );
  const valleyAccount = enabledAccounts.find(
    (bankAccount) =>
      (bankAccount.name || '').trim().toLowerCase() ===
      DEFAULT_RECEIVING_BANK_NAME.toLowerCase()
  );
  return valleyAccount?.id || enabledAccounts[0]?.id || '';
}

export function getTwelveBankAccountLabel(bankAccounts, accountId) {
  if (!accountId) {
    return '';
  }
  const account = (bankAccounts || []).find(
    (bankAccount) => bankAccount.id === accountId
  );
  return formatTwelveBankAccountLabel(account);
}
